import React from 'react';
import PropTypes from 'prop-types';
import {Button,ButtonGroup} from 'react-bootstrap/';
import {FaUserPlus,FaUserMinus} from "react-icons/fa";
export const Change = ({handleOccupy, handleVacate, canOccupy, canVacate}) =>{
	return(
		<>
			<br/>
			<ButtonGroup vertical>
				{canOccupy 
					?
						<Button onClick={handleOccupy}><FaUserPlus style={{fontSize:'xxx-large'}}/></Button>
					:
						<Button disabled><FaUserPlus style={{fontSize:'xxx-large'}}/></Button>
				}
				{canVacate 
					?
						<Button onClick={handleVacate} className="bg-dark"><FaUserMinus  style={{fontSize:'xxx-large'}}/></Button>
					:
						<Button disabled className="bg-dark"><FaUserMinus  style={{fontSize:'xxx-large'}}/></Button>
				}
			</ButtonGroup>
			<br/>
			<br/>
		</>
	)

}
Change.propTypes = {
	handleOccupy: PropTypes.func,
	handleVacate: PropTypes.func,
	canOccupy: PropTypes.bool,
	canVacate: PropTypes.bool
};
